import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  NgForm,
} from '@angular/forms';
import Swal from 'sweetalert2';
import { InvoiceBuyOrdersService } from '../../service/invoice-buy-orders.service';
import { filter, finalize, map } from 'rxjs';
import {
  AddOrUpdateInvoiceBuyOrder,
  InvoiceBuyOrderViewModel,
} from '../../interface/buy-order.interface';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  faDownload,
  faEye,
  faFileDownload,
} from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-purchase-order',
  templateUrl: './purchase-order.component.html',
  styleUrls: ['./purchase-order.component.scss'],
})
export class PurchaseOrderComponent implements OnInit {
  @ViewChild('inputFile') fileInputElement: ElementRef;

  public icons = {
    faEye,
  };

  // Indica si factura tiene orden de compra asociada
  hasBuyOrder: boolean = false;

  // Url de documento adjunto a orden de compra
  documentUri: string | null = null;

  public isBuyOrderModified: boolean = false;

  public isLoading: boolean = false;
  validate: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: number,
    private dialogRef: MatDialogRef<PurchaseOrderComponent>,
    private invoiceBuyOrderService: InvoiceBuyOrdersService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.fetchInvoiceBuyOrder(this.data);
  }

  form = new FormGroup({
    code: new FormControl<string | null>('', [Validators.required]),
    amount: new FormControl<number | null>(null, [Validators.required]),
    fechaEmision: new FormControl<string | null>(null, [Validators.required]),
    plazo: new FormControl<number | null>(null, [Validators.required]),
    sigfe: new FormControl<boolean>(false),
    file: new FormControl(null, [this.validatePdfFile]),
  });

  get f() {
    return this.form.controls;
  }

  selectedFile: any = null;

  public fetchInvoiceBuyOrder(invoiceId: number) {
    this.invoiceBuyOrderService
      .getInvoiceBuyOrder(invoiceId)
      .pipe(
        filter((buyOrderResponse) => buyOrderResponse != null),
        map((buyOrderResponse) => {
          return {
            code: buyOrderResponse.code,
            amount: buyOrderResponse.amount,
            fechaEmision: buyOrderResponse.fechaEmision,
            plazo: buyOrderResponse.plazo,
            sigfe: buyOrderResponse.sigfe,
            documentUri: buyOrderResponse.documentUri,
          } as InvoiceBuyOrderViewModel;
        })
      )
      .subscribe({
        next: (response) => {
          this.setForm(response);
        },
      });
  }

  validatePdfFile(control: any): { [key: string]: any } | null {
    const file = control.value;
    if (file === null || file === undefined) {
      return null; // No hay archivo, la validación pasa
    }
    const fileName: string = file.name.toLowerCase();

    // Verificar la extensión y el tipo MIME del archivo
    if (fileName.endsWith('.pdf') && file.type === 'application/pdf') {
      return null; // El archivo es un PDF válido, la validación pasa
    } else {
      return { invalidPdf: true }; // El archivo no es un PDF válido, la validación falla
    }
  }
  private setForm(buyOrder: InvoiceBuyOrderViewModel | null) {
    this.hasBuyOrder = buyOrder != null;
    if (buyOrder != null) {
      this.form.patchValue({
        code: buyOrder.code,
        amount: buyOrder.amount,
        plazo: buyOrder.plazo,
        fechaEmision: new Date(buyOrder.fechaEmision)
          .toISOString()
          .split('T')[0],
        sigfe: buyOrder.sigfe,
        // file: buyOrder.documentUri
      });
      this.documentUri = buyOrder.documentUri;
    }
  }

  private resetFileFormControl() {
    this.fileInputElement.nativeElement.value = '';
    this.form.patchValue({
      file: null,
    });
  }

  onFileSelected(event: any): void {
    const files: any = (event.target as HTMLInputElement).files;

    if (files && files.length > 0) {
      const file = files[0];
      const fileName: string = file.name.toLowerCase();

      // Verificar la extensión y el tipo MIME del archivo
      if (fileName.endsWith('.pdf') && file.type === 'application/pdf') {
        this.form.patchValue({ file: file });
        this.form.get('file')?.setErrors(null); // Limpiar cualquier error previo
      } else {
        console.log('Por favor, selecciona un archivo PDF válido.');
        this.form.get('file')?.setErrors({ invalidPdf: true }); // Agregar error personalizado
      }
    }
  }

  submitForm() {
    const { code, amount, fechaEmision, sigfe, plazo, file } = this.form.value;
    const request: AddOrUpdateInvoiceBuyOrder = {
      invoiceId: this.data,
      code: code!,
      amount: amount!,
      fechaEmision: fechaEmision!,
      plazo: plazo!,
      sigfe: sigfe!,
      document: file!,
    };

    this.isLoading = true;
    this.invoiceBuyOrderService
      .addOrUpdateInvoiceBuyOrder(this.data, request)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (response) => {
          this.toastr.success(
            `Orden de compra ${
              this.hasBuyOrder ? 'actualizada' : 'agregada'
            } exitosamente`,
            'Orden de compra'
          );
          this.resetFileFormControl();
          this.fetchInvoiceBuyOrder(this.data);
          this.isBuyOrderModified = true;
          this.closeDialog();
        },
        error: (error) => {
          this.toastr.error(error.error.resultMessage, 'Orden de compra');
        },
      });
  }
  closeDialog() {
    this.dialogRef.close(this.isBuyOrderModified);
  }
}
